/**
 * Trigger a browser download of `text` as `filename`. Used by the wallet-export
 * UI to save keystore JSON. Mirrors the v1 approach (Blob → object URL → click).
 */
export function downloadTextFile(text: string, filename: string): void {
  const blob = new Blob([text], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}
